module.exports = __webpack_public_path__ + "static/36-U2-sept2014-option1-8822a101b62a52bd0d880d1f77518bd7.jpg";